import { OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';
import { ControlledTextInput } from '../ControlledInputs';

interface IinputProps {
  disabled: boolean;
  tabIndex: number;
}
export const ZipInput = ({ tabIndex, disabled }: IinputProps) => {
  return (
    <ControlledTextInput
      name={OnboardingFormFields.ZIP}
      title={t('pages.businessAddress.fields.zip')}
      // id={'postalCode'}
      id={OnboardingFormFields.ZIP}
      disabled={disabled}
      tabindex={tabIndex}
      props={{ maxLength: 5, onChange: () => {}, id: '', title: '' }}
      filterType={'num'}
    />
  );
};
